import {apiPath} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {IRootState} from "../../store/store";
import {getIgnoredNotifyResponse} from "../../store/utils/get_ignored_notify_response";
import {ISurveyData} from "../../user/types/IBuildSurveyParams";
import {selectIsUserAuthenticated} from "../../user/utils/select_is_user_authenticated";

export const getClientInfoApi = rpApi.injectEndpoints({
    endpoints: (builder) => ({
        getClientInfo: builder.query<ISurveyData | null, void>({
            queryFn: async (_arg, queryApi, _extraOptions, baseQuery) => {
                const isAuthenticated = selectIsUserAuthenticated(queryApi.getState() as IRootState);

                if (!isAuthenticated) {
                    return {data: null};
                }

                const result = await baseQuery({
                    url: apiPath.applications.client.base,
                    method: "GET"
                });

                if (result.error) {
                    return {
                        error: getIgnoredNotifyResponse(result.error, [404])
                    };
                }

                return {data: result.data as ISurveyData};
            }
        })
    })
});

export const {useGetClientInfoQuery} = getClientInfoApi;
import {apiPath} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {IRootState} from "../../store/store";
import {getIgnoredNotifyResponse} from "../../store/utils/get_ignored_notify_response";
import {ISurveyData} from "../../user/types/IBuildSurveyParams";
import {selectIsUserAuthenticated} from "../../user/utils/select_is_user_authenticated";

export const getClientInfoApi = rpApi.injectEndpoints({
    endpoints: (builder) => ({
        getClientInfo: builder.query<ISurveyData | null, void>({
            queryFn: async (_arg, queryApi, _extraOptions, baseQuery) => {
                const isAuthenticated = selectIsUserAuthenticated(queryApi.getState() as IRootState);

                if (!isAuthenticated) {
                    return {data: null};
                }

                const result = await baseQuery({
                    url: apiPath.applications.client.base,
                    method: "GET"
                });

                if (result.error) {
                    return {
                        error: getIgnoredNotifyResponse(result.error, [404])
                    };
                }

                return {data: result.data as ISurveyData};
            }
        })
    })
});

export const {useGetClientInfoQuery} = getClientInfoApi;
